import type { FlowDefinition, RequestItem } from '../../types';
import { REQUEST_FLOW_FIELD_IDS } from '../../lib/flowFieldExtensions';
import { VASE_FLOW_FIELD_IDS } from '../../lib/flows';

export function findFlowNodeIdByType(flow: FlowDefinition | null | undefined, blockType: string) {
  return flow?.nodes.find((node) => node.blockType === blockType)?.id ?? null;
}

export function removeRequestItemFromFlow(args: {
  flow: FlowDefinition;
  flowId: string;
  item: RequestItem;
  removeNodeId: string;
  patchFlowValues: (flowId: string, values: Record<string, unknown>) => void;
  invokeFlowNode: (flowId: string, nodeId: string) => void;
}) {
  const { flow, flowId, item, removeNodeId, patchFlowValues, invokeFlowNode } = args;
  const removeNode = flow.nodes.find((node) => node.id === removeNodeId) ?? null;
  const removeItemFieldId =
    removeNode?.inputs.find((binding) => binding.socketId === 'item')?.fieldId ??
    REQUEST_FLOW_FIELD_IDS.currentRequestItem;
  patchFlowValues(flowId, {
    [VASE_FLOW_FIELD_IDS.chosenProduct]: item.product ?? undefined,
    [VASE_FLOW_FIELD_IDS.chosenFinish]: item.finish ?? undefined,
    [VASE_FLOW_FIELD_IDS.chosenColours]: item.colours,
    [VASE_FLOW_FIELD_IDS.chosenCombination]: item.combination ?? undefined,
    [REQUEST_FLOW_FIELD_IDS.currentRequestItem]: item,
    [removeItemFieldId]: item,
  });
  invokeFlowNode(flowId, removeNodeId);
}
